module.exports = __webpack_public_path__ + "adcaf8a961598bd40d3f9c1163beec96.png";